export const tid = (id: string) => {
    return {'data-tid': id};
};
